import { CognitoUserAttribute, CognitoUserPool, ISignUpResult } from "amazon-cognito-identity-js";
import { Formik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { CREATE_ORG_USER, CREATE_USER, GET_APP_ROLES } from "../../../../queries";

// Interface with parent
//
interface OrgUsers {
    shouldRefreshUsers: Function
}

const RegisterForm = (props: any) => {
    const [userRoles, setUserRoles] = useState<any>(null);
    console.log("RegisterForm props", props);
    useEffect(() => {
        (async function fetchData() {
            const resultRoles:any = await loadRoles();
            setUserRoles(resultRoles.data.syncarto_app_role);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const registerUser = (email: string, password: string) => {
        const poolData = {
            UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
            ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || ''
        };

        const userPool = new CognitoUserPool(poolData);
        const attributeList: CognitoUserAttribute[] = [];

        const dataEmail = {
            Name: 'email',
            Value: email
        };
        const dataName = {
            Name: 'name',
            Value: email
        };

        const attributeEmail = new CognitoUserAttribute(dataEmail);
        attributeList.push(attributeEmail);

        const attributeName = new CognitoUserAttribute(dataName);
        attributeList.push(attributeName);

        return new Promise(function (resolve, reject) {
            userPool.signUp(email, password, attributeList, [], function (err?: Error, result?: ISignUpResult) {
                if (err) {
                    reject(err);
                }
                if (result) {
                    resolve(result.userSub);
                } else {
                    reject('No sign up result found!');
                }
            });
        });
    }

    const loadRoles = () => {
        return props.client.query({
            query: GET_APP_ROLES,
            variables: {},
            optimisticResponse: null
        });
    }

    const createUser = (userData:any) => {
        console.log("createUser userData", userData);
        console.log("createUser props", props);
        var data = {
            id: userData.id,
            name: userData.name,
            email: userData.email,
            org_id: props.orgId
        };

        return props.client.mutate({
            mutation: CREATE_USER,
            variables: data,
            optimisticResponse: null
        });  
    }

    const createOrgUser = (userData:any) => {
        console.log("creatOrgUser userData, ", userData)
        var data = {
            user_id: userData.id,
            role_id: userData.role,
            org_id: props.orgId
        };

        console.log(data);

        return props.client.mutate({
            mutation: CREATE_ORG_USER,
            variables: data,
            optimisticResponse: null
        });  
    }

    if(userRoles == null) {
        return (
            <div>Loading...</div>
        )
    }

    const validate = (values:any) => {
        var errors: {[k: string]: any} = {};

        console.log(values);

        if (values.email === "") {
          errors.email = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email)) {
          errors.email = 'Invalid email address';
        }

        if (values.name === "") {
            errors.name = 'Required';
        }

        if (values.password === "") {
            errors.password = 'Required';
        }

        if (values.role === undefined) {
            errors.role = 'Required';
        }

        return errors;
      };

    return (
        <Formik 
            initialValues= {{ 
                name:"", 
                email: props.emailSignup ? props.emailSignup : "", 
                password:"", 
                role:undefined,
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validate={validate}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true);
                console.log("submitting...");

                try {
                    let userData = {
                        name: values.name,
                        email: values.email,
                        password: values.password,
                        role: values.role,
                    };

                    const cognitoId = await registerUser(userData.email, userData.password);
                    await createUser({...userData, id: cognitoId});
                    await createOrgUser({...userData, id: cognitoId});

                    //alert('072721 User account created');

                    setTimeout(() => {
                        const { shouldRefreshUsers } = props;
                        shouldRefreshUsers();
                    },500);

                    resetForm();
                } catch(e) {
                    console.error(e);
                    if(e.code) {
                        alert(e.message);
                    }
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <>
                <h4>Create User</h4>
                <Form noValidate onSubmit={handleSubmit} autoComplete="off" style={{marginTop: "10px", padding:"1em"}}>
                    <Form.Group controlId="formName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            placeholder="Enter user's name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                    </Form.Group>
                    <Form.Group controlId="formEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.password}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.password}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formRole">
                        <Form.Label>Role</Form.Label>
                        <select
                            name="role"
                            value={values.role}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={"form-control" + (errors.role ? " is-invalid" : "")}
                        >
                            <option value="" label="Select a role" />
                            {
                                userRoles.map((role: any) => {
                                    return (
                                        <option key={role.id} value={role.id}>{role.name}</option>
                                    );
                                })
                            }
                        </select>
                        {
                            errors.role && 
                            <div className="invalid-feedback">
                                {errors.role}
                            </div>
                        }
                    
                    </Form.Group>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Submit
                    </Button>
                </Form>
                </>
          )}
        </Formik>
    );
}

export default RegisterForm;